import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import AOS from "aos";
import "aos/dist/aos.css";
import "./style.css";

const Pricing = () => {
	const [billingCycle, setBillingCycle] = useState("oneTime"); // 'oneTime' or 'monthly'

	useEffect(() => {
		AOS.init({ duration: 1000, once: true });
	}, []);

	return (
		<div className="pricing-body">
			<div className="pricing-container" data-aos="fade-up">
				<Helmet>
					<title>Moonface Techs | Pricing & Tiers</title>
					<meta
						name="description"
						content="Affordable web development and support packages by Moonface Techs."
					/>
				</Helmet>

				<header className="pricing-header">
					<h1>Transparent Pricing</h1>
					<p>Professional, budget-friendly web solutions tailored for your business growth.</p>
					
					<div className="pricing-toggle">
						<button
							className={billingCycle === "oneTime" ? "toggle-btn active" : "toggle-btn"}
							onClick={() => setBillingCycle("oneTime")}
						>
							Project Builds
						</button>
						<button
							className={billingCycle === "monthly" ? "toggle-btn active" : "toggle-btn"}
							onClick={() => setBillingCycle("monthly")}
						>
							Monthly Retainers
						</button>
					</div>
				</header>

				{billingCycle === "oneTime" ? (
					<div className="pricing-grid" data-aos="fade-up">
						{/* Tier 1 */}
						<div className="pricing-card">
							<span className="tier-badge">Tier 1</span>
							<h2>Essential Landing Page</h2>
							<div className="price">R3,500</div>
							<p className="price-sub">One-time payment</p>
							<ul className="feature-list">
								<li>Single-page responsive layout</li>
								<li>Contact form (EmailJS integration)</li>
								<li>Basic on-page SEO (React Helmet)</li>
								<li>Mobile-first optimization</li>
							</ul>
							<a href="/contact" className="pricing-btn">Get Started</a>
						</div>

						{/* Tier 2 */}
						<div className="pricing-card popular">
							<span className="popular-badge">Most Popular</span>
							<span className="tier-badge">Tier 2</span>
							<h2>Professional Business Website</h2>
							<div className="price">R6,000</div>
							<p className="price-sub">One-time payment</p>
							<ul className="feature-list">
								<li>Up to 5 custom pages (Home, About, Services, Contact, etc.)</li>
								<li>Custom React components & CSS styling</li>
								<li>Advanced responsive design</li>
								<li>Integrated contact & feedback forms</li>
							</ul>
							<a href="/contact" className="pricing-btn popular-btn">Get Started</a>
						</div>

						{/* Tier 3 */}
						<div className="pricing-card">
							<span className="tier-badge">Tier 3</span>
							<h2>Custom Web App & E-Commerce</h2>
							<div className="price">R12,000+</div>
							<p className="price-sub">Custom Quote</p>
							<ul className="feature-list">
								<li>Full-stack architecture (Firebase Auth, Database)</li>
								<li>User dashboards & secure routing</li>
								<li>Tailored backend logic</li>
								<li>Ticketing / Client portal integration</li>
							</ul>
							<a href="/contact" className="pricing-btn">Request Quote</a>
						</div>
					</div>
				) : (
					<div className="pricing-grid" data-aos="fade-up">
						{/* Basic Support */}
						<div className="pricing-card">
							<span className="tier-badge">Support</span>
							<h2>Basic Support</h2>
							<div className="price">R500 <span className="month-tag">/mo</span></div>
							<p className="price-sub">Billed monthly</p>
							<ul className="feature-list">
								<li>Up to 2 minor text/image updates</li>
								<li>Monthly security & dependency checks</li>
								<li>Ticketing system access</li>
								<li>48 – 72 hour turnaround</li>
							</ul>
							<a href="/contact" className="pricing-btn">Select Plan</a>
						</div>

						{/* Pro Maintenance */}
						<div className="pricing-card popular">
							<span className="popular-badge">Recommended</span>
							<span className="tier-badge">Maintenance</span>
							<h2>Pro Maintenance</h2>
							<div className="price">R1,200 <span className="month-tag">/mo</span></div>
							<p className="price-sub">Billed monthly</p>
							<ul className="feature-list">
								<li>Up to 5 small feature updates or changes</li>
								<li>Priority ticketing queue</li>
								<li>Regular backups & performance checks</li>
								<li>24-hour turnaround time</li>
							</ul>
							<a href="/contact" className="pricing-btn popular-btn">Select Plan</a>
						</div>

						{/* Enterprise Retainer */}
						<div className="pricing-card">
							<span className="tier-badge">Enterprise</span>
							<h2>Enterprise Retainer</h2>
							<div className="price">R2,800+ <span className="month-tag">/mo</span></div>
							<p className="price-sub">Billed monthly</p>
							<ul className="feature-list">
								<li>Dedicated development hours per month</li>
								<li>Rapid-response ticketing & urgent fixes</li>
								<li>Ongoing feature expansion</li>
								<li>Same-day response time</li>
							</ul>
							<a href="/contact" className="pricing-btn">Contact Us</a>
						</div>
					</div>
				)}
			</div>
		</div>
	);
};

export default Pricing;